import { createAsyncAction } from "../../helpers/actions"
import { passwordResetRequest as api } from "../api/passwordResetRequest"
import { PASSWORD_RESET_REQUEST } from "../constants/ActionTypes"

export const passwordResetRequest = createAsyncAction<string, [string]>(
  PASSWORD_RESET_REQUEST,
  api
)
